import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';

export enum MailIconVariant {
  DEFAULT = 'default',
  CHECK = 'check',
  ERROR = 'error',
}
export interface IMailIconProps extends IConDefaultType {
  variant?: MailIconVariant;
}

export default function MailIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = MailIconVariant.DEFAULT,
}: IMailIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === MailIconVariant.DEFAULT && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="5" width="18" height="14" rx="4" stroke="#303037" strokeWidth="2" />
          <path
            d="M3.00025 7.39999L10.8908 12.6604C11.5626 13.1083 12.4378 13.1083 13.1096 12.6604L21.0002 7.4"
            stroke="#303037"
            strokeWidth="2"
          />
        </svg>
      )}
      {variant === MailIconVariant.CHECK && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 4C4.23858 4 2 6.23858 2 9V15C2 17.7614 4.23858 20 7 20H12.3414C12.1203 19.3744 12 18.7013 12 18H7C5.34315 18 4 16.6569 4 15V9C4 7.34315 5.34315 6 7 6H17C18.6569 6 20 7.34315 20 9V12.3414C20.7452 12.6048 21.4229 13.0113 22 13.5278V9C22 6.23858 19.7614 4 17 4H7Z"
            fill="#303037"
          />
          <path
            d="M3.00025 7.39999L10.8908 12.6604C11.5626 13.1083 12.4378 13.1083 13.1096 12.6604L21.0002 7.4"
            stroke="#303037"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 22C20.2091 22 22 20.2091 22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22ZM20.495 17.495C20.7683 17.2216 20.7683 16.7784 20.495 16.505C20.2216 16.2317 19.7784 16.2317 19.505 16.505L17.5 18.5101L16.495 17.505C16.2216 17.2317 15.7784 17.2317 15.505 17.505C15.2317 17.7784 15.2317 18.2216 15.505 18.495L17.005 19.995C17.2784 20.2683 17.7216 20.2683 17.995 19.995L20.495 17.495Z"
            fill="#00C3DD"
          />
        </svg>
      )}
      {variant === MailIconVariant.ERROR && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 4C4.23858 4 2 6.23858 2 9V15C2 17.7614 4.23858 20 7 20H12.3414C12.1203 19.3744 12 18.7013 12 18H7C5.34315 18 4 16.6569 4 15V9C4 7.34315 5.34315 6 7 6H17C18.6569 6 20 7.34315 20 9V12.3414C20.7452 12.6048 21.4229 13.0113 22 13.5278V9C22 6.23858 19.7614 4 17 4H7Z"
            fill="#303037"
          />
          <path
            d="M3.00025 7.39999L10.8908 12.6604C11.5626 13.1083 12.4378 13.1083 13.1096 12.6604L21.0002 7.4"
            stroke="#303037"
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 18C22 20.2091 20.2091 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18ZM18 15.4C18.4418 15.4 18.8 15.7582 18.8 16.2V17.7C18.8 18.1418 18.4418 18.5 18 18.5C17.5582 18.5 17.2 18.1418 17.2 17.7V16.2C17.2 15.7582 17.5582 15.4 18 15.4ZM18.0002 20.8C18.442 20.8 18.8002 20.4418 18.8002 20C18.8002 19.5582 18.442 19.2 18.0002 19.2C17.5584 19.2 17.2002 19.5582 17.2002 20C17.2002 20.4418 17.5584 20.8 18.0002 20.8Z"
            fill="#FE008A"
          />
        </svg>
      )}
    </i>
  );
}
